import React, { useState } from 'react';
import './StoryPage.css';

const StoryPage = ({ template, userWords, onBackToCover }) => {
    const [showPrintMenu, setShowPrintMenu] = useState(false);

    // Safety check - if no template, don't render
    if (!template || !template.story || !template.wordList) {
        return <div>Loading...</div>;
    }

    const generateFilledStory = () => {
        let story = template.story;
        template.wordList.forEach((item) => {
            const regex = new RegExp(`\\{${item.number}\\}`, 'g');
            const word = userWords[item.number] || `[${item.prompt}]`;
            story = story.replace(regex, `<span class="filled-word">${word}</span>`);
        });
        return story;
    };

    const printVersion = (populated) => {
        try {
            const printWindow = window.open('', '_blank');
            
            // Check if window.open was blocked
            if (!printWindow) {
                alert('Please allow popups to print your Mad Lib. Check your browser settings and try again.');
                return;
            }
            
            if (populated) {
                // Print populated version
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Mad Fills - Your Story</title>
                        <style>
                            body { font-family: 'Courier New', monospace; padding: 2rem; }
                            h1 { text-align: center; font-family: Impact, sans-serif; }
                            .story { font-size: 1.2rem; line-height: 2.5; max-width: 600px; margin: 2rem auto; }
                            .filled-word { background: yellow; padding: 2px 4px; font-weight: bold; }
                        </style>
                    </head>
                    <body>
                        <h1>YOUR MAD FILLS STORY</h1>
                        <div class="story">${generateFilledStory()}</div>
                    </body>
                    </html>
                `);
            } else {
                // Print unpopulated version
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Mad Fills - Blank Version</title>
                        <style>
                            body { font-family: 'Courier New', monospace; padding: 2rem; }
                            h1, h2 { text-align: center; font-family: Impact, sans-serif; }
                            .word-list { max-width: 500px; margin: 2rem auto; }
                            .word-item { margin: 1rem 0; display: flex; gap: 1rem; }
                            .story { font-size: 1.2rem; line-height: 2.5; max-width: 600px; margin: 2rem auto; page-break-before: always; }
                            .blank { border-bottom: 2px solid black; display: inline-block; min-width: 100px; }
                        </style>
                    </head>
                    <body>
                        <h1>MAD FILLS</h1>
                        <h2>Word List</h2>
                        <div class="word-list">
                            ${template.wordList.map(item => `
                                <div class="word-item">
                                    <strong>${item.number}.</strong> ${item.prompt}: <span class="blank"></span>
                                </div>
                            `).join('')}
                        </div>
                        <h2>Your Story</h2>
                        <div class="story">
                            ${template.story.replace(/\{(\d+)\}/g, '(<span class="blank">$1</span>)')}
                        </div>
                    </body>
                    </html>
                `);
            }
            
            printWindow.document.close();
            
            // Small delay to ensure content is loaded before printing
            setTimeout(() => {
                try {
                    printWindow.print();
                } catch (printError) {
                    console.error('Print failed:', printError);
                    alert('Printing failed. Please try again or check your printer settings.');
                }
            }, 100);
            
        } catch (error) {
            console.error('Print window creation failed:', error);
            alert('Unable to open print window. Please check your browser settings and try again.');
        }
    };

    return (
        <div className="story-page-container">
            <div className="story-content">
                <h1 className="booklet-title">YOUR HILARIOUS STORY!</h1>
                <div 
                    className="completed-story story-text"
                    dangerouslySetInnerHTML={{ __html: generateFilledStory() }}
                />
                
                <div className="action-buttons">
                    <button 
                        onClick={() => setShowPrintMenu(!showPrintMenu)} 
                        className="print-menu-button booklet-title"
                    >
                        🖨️ PRINT OPTIONS
                    </button>

                    {showPrintMenu && (
                        <div className="print-menu">
                            <button onClick={() => printVersion(false)} className="print-option">
                                Print Blank Version
                            </button>
                            <button onClick={() => printVersion(true)} className="print-option">
                                Print Filled Version
                            </button>
                        </div>
                    )}

                    <button onClick={onBackToCover} className="do-another-button">
                        🎉 AWESOME, DO ANOTHER!
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StoryPage;